export type BinaryResponse = {
    data: BlobPart | Blob;
    headers?: Record<string, string | undefined>;
};

const RFC5987_FILENAME_REGEX = /filename\*=UTF-8''([^;]+)/i;
const FILENAME_REGEX = /filename="?([^";]+)"?/i;

export const resolveBinaryDownloadFileName = (
    contentDisposition?: string,
    fallbackFileName: string = 'download',
) => {
    if (!contentDisposition) {
        return fallbackFileName;
    }

    const matchedFileName =
        contentDisposition.match(RFC5987_FILENAME_REGEX)?.[1] ||
        contentDisposition.match(FILENAME_REGEX)?.[1];
    if (!matchedFileName) {
        return fallbackFileName;
    }

    const sanitizedFileName = matchedFileName.replace(/"/g, '').replace(/;/g, '').trim();
    if (!sanitizedFileName) {
        return fallbackFileName;
    }

    try {
        return decodeURIComponent(sanitizedFileName);
    } catch {
        return sanitizedFileName;
    }
};

export const downloadBinaryResponse = (
    response: BinaryResponse,
    opts?: { fallbackFileName?: string },
) => {
    const fallbackFileName = opts?.fallbackFileName || 'download';
    const fileName = resolveBinaryDownloadFileName(response.headers?.['content-disposition'], fallbackFileName);
    const blob = response.data instanceof Blob ? response.data : new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return fileName;
};
